import { render, staticRenderFns } from "./cangchuCkPup.vue?vue&type=template&id=38ed9547&scoped=true&"
import script from "./cangchuCkPup.vue?vue&type=script&lang=js&"
export * from "./cangchuCkPup.vue?vue&type=script&lang=js&"
import style0 from "./cangchuCkPup.vue?vue&type=style&index=0&id=38ed9547&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed9547",
  null
  
)

export default component.exports